import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue';
import { Member } from '@/models/member';
import { groupByTag } from '@/services/members';
import { useStore } from '@/composables/use-globals';
import { useFeature } from '@/composables/use-feature';


export default /*#__PURE__*/_defineComponent({
  __name: 'GroupedMemberView',
  props: {
  openPanels: {
    type: Array as () => number[],
    default: () => {
      return null;
    },
  },
  members: {
    type: Array as () => Member[],
    required: true,
  },
},
  setup(__props) {

const props = __props

const store = useStore();
const openedPanels = ref([] as Array<number>);


const enableAbilityGroups = useFeature(store, 'ABILITY_GROUPS');

const ungroupedMembers = computed(() => {
  if (!enableAbilityGroups.value) {
    return props.members;
  }
  return props.members.filter(member => !member.tags || member.tags.length === 0);
});

const groupedMembers = computed(() => {
  if (!enableAbilityGroups.value) {
    return [];
  }
  return groupByTag(props.members);
});

function onExpansionPanelClick(index: number) {
  const openedPanelsArray = JSON.parse(JSON.stringify(openedPanels.value));

  const i = openedPanelsArray.indexOf(index);
  if (i > -1) {
    openedPanelsArray.splice(i, 1);
  } else {
    openedPanelsArray.push(index);
  }
  store.dispatch('groups/updateAssessByMemberOpenPanelList', openedPanelsArray);
}

onMounted(() => {
  openedPanels.value = props.openPanels;
});

return { __sfc: true,store, openedPanels, props, enableAbilityGroups, ungroupedMembers, groupedMembers, onExpansionPanelClick }
}

})